// When an event is, in words. Read by ThEventHero, ThEventWhen and
// ThEventSignup, which all print some part of the same sentence — one
// definition so the hero's "Saturday, June 14" and the aside's
// "Sat Jun 14" can never be two different days.
//
// `date` is a calendar day (YYYY-MM-DD), so it goes through
// parseCalendarDate: `new Date('2026-06-14')` is UTC midnight and
// renders as the 13th for every reader west of Greenwich.

import { parseCalendarDate } from '@/lib/calendarDate';

export function eventDay(event) {
    return event?.date ? parseCalendarDate(event.date) : null;
}

// The month / day pair for the design's calendar tile.
export function dateTile(event) {
    const d = eventDay(event);
    if (!d) return { month: 'MMM', day: 'DD' };
    return {
        month: d.toLocaleDateString('en-US', { month: 'short' }).toUpperCase(),
        day: String(d.getDate()),
    };
}

export function dateLong(event, withYear = false) {
    const d = eventDay(event);
    if (!d) return null;
    return d.toLocaleDateString('en-US', {
        weekday: 'long',
        year: withYear ? 'numeric' : undefined,
        month: 'long',
        day: 'numeric',
    });
}

export function dateShort(event) {
    const d = eventDay(event);
    if (!d) return null;
    return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
}

function clockTime(t) {
    const [h, m] = String(t).split(':').map(Number);
    if (Number.isNaN(h)) return '';
    return new Date(2000, 0, 1, h, m || 0)
        .toLocaleTimeString('en-US', { hour: 'numeric', minute: m === 0 ? undefined : '2-digit' });
}

// "9 AM to 1 PM", "All day", or nothing at all when the event only
// says which day it is.
export function timeRange(event) {
    if (!event) return null;
    if (event.all_day) return 'All day';
    if (!event.start_time) return null;
    const from = clockTime(event.start_time);
    return event.end_time ? `${from} to ${clockTime(event.end_time)}` : from;
}

// One option in the recurring-event occurrence picker.
export function occurrenceLabel(ymd) {
    const d = parseCalendarDate(ymd);
    return d ? d.toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric' }) : String(ymd ?? '');
}
